const React = require('react');

const Container = require('./Container.jsx');
const Content = require('./Content.jsx');
const Token = require('../utility/Token.jsx');
const TypeConfig = require('./TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region DISCOUNT

function Discount(props) {
    const data = props.data || {};
    let formatValue, value;
    if (data.HasDiscount) {
        if (data.DiscountType == 2) {
            value = data.Discount;
        } else {
            formatValue = false;

            let formatProps = {}
            if (props.config && props.config.Config && props.config.Config.Format) {
                formatProps = props.config.Config.Format;
            }
            value = Utilities.Format.Percent.getDisplayString(data.Discount, formatProps.percentFormat);
        }
    }
    return <Content.LabelValue {...props} formatValue={formatValue} renderPlaceholder={!value} value={value} />;
}
const TypeConfigDiscount = {
    panel: {
        block: function () { return Content.TypeConfig.labelValue.panel.block({ value: 'Discount' }); },
        format: function () { return TypeConfig.panel.currency({ percent: true }); },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

// #endregion DISCOUNT

// #region DISCOUNT V2

function _DiscountV2(props) {
    const hasValue = props.data && props.data.HasDiscount;
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const DiscountV2 = Content.withLabelTokenParsing(_DiscountV2, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Discount:
            if (data.Discount != undefined) {
                replaceString = Utilities.Format.getDiscountString(data, props.index, props.data && props.data.Gallery && props.data.Gallery.Localization, options);
            }
            break;
        case Token.DisplayCurrency.Discount:
            if (data.DiscountType != 1 && data.ExchangeRate && data.ExchangeRate.Discount != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Discount, options);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensDiscount = (data) => {
    const discountToken = Token.getCurrencyTokenConfig('Discount', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Discount);
    discountToken.options.push({ defaultValue: Utilities.Format.Percent.getDefaultFormatString() , display: 'Percent Format', name: 'percentFormat', note: 'Keywords: [Value]', type: 'percentFormat' })
    return [
        discountToken,
        Token.getWrappedTokenConfig('Discount (Display Currency)', Token.DisplayCurrency.Discount)
    ];
};
const TypeConfigDiscountV2 = {
    panel: {
        block: Content.TypeConfig.labelValue.panelV2.block,
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: 'Discount' })),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: (data) => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Discount}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}","percentFormat":"${Utilities.Format.Percent.getDefaultFormatString()}")}`, token: Token.Discount }))
    }
};

// #endregion DISCOUNT V2

// #region GRAND TOTAL

function GrandTotal(props) {
    const data = props.data || {};
    return <Content.LabelValue {...props} value={data.Total} />;
}
const TypeConfigGrandTotal = {
    panel: {
        block: function () { return Content.TypeConfig.labelValue.panel.block({ value: 'Grand Total' }); },
        format: Content.TypeConfig.labelValue.panel.format,
        style: Content.TypeConfig.labelValue.panel.style
    }
};

// #endregion GRAND TOTAL

// #region GRAND TOTAL V2

function _GrandTotalV2(props) { return <Content.LabelValue {...props} formatValue={false} value={props.content} /> }
const GrandTotalV2 = Content.withLabelTokenParsing(_GrandTotalV2, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.GrandTotal:
            if (data.ExchangeRate && data.ExchangeRate.Total != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Total, options);
            }
            break;
        case Token.Total.GrandTotal:
            if (data.Total != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Total, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensGrandTotal = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Grand Total', defaultValue, Token.Total.GrandTotal),
        Token.getWrappedTokenConfig('Grand Total (Display Currency)', Token.DisplayCurrency.GrandTotal)
    ];
};
const TypeConfigGrandTotalV2 = {
    panel: {
        block: Content.TypeConfig.labelValue.panelV2.block,
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: (display) => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: display || 'Grand Total' })),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: (data) => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.GrandTotal}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.GrandTotal }))
    }
};

// #endregion GRAND TOTAL V2

// #region SHIPPING

function Shipping(props) {
    const data = props.data || {};
    const config = props.config || {};
    let includes = {};
    if (config.Config && config.Config.Includes) {
        includes = config.Config.Includes;
    }
    let value;
    if (includes.ShippingZero || (!includes.ShippingZero && data.Shipping != 0)) {
        value = data.Shipping;
    }
    return <Content.LabelValue {...props} renderPlaceholder={value == undefined} value={value} />;
}
const TypeConfigShipping = {
    panel: {
        block: function () { return Content.TypeConfig.labelValue.panel.block({ value: 'Shipping' }); },
        format: Content.TypeConfig.labelValue.panel.format,
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'If shipping is 0', name: 'ShippingZero', type: 'checkbox', value: true }
                ]
            };
        },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

// #endregion SHIPPING

// #region SHIPPING V2

function _ShippingV2(props) {
    const data = props.data || {};
    const blockProps = props.config && props.config.config && props.config.config.Block || {};
    let hasValue;
    if (blockProps.includeShippingZero || (!blockProps.includeShippingZero && data.Shipping != 0)) {
        hasValue = true;
    }
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const ShippingV2 = Content.withLabelTokenParsing(_ShippingV2, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.Shipping:
            if (data.ExchangeRate && data.ExchangeRate.Shipping != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Shipping, options);
            }
            break;
        case Token.Total.Shipping:
            if (data.Shipping != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Shipping, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensShipping = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Shipping', defaultValue, Token.Total.Shipping),
        Token.getWrappedTokenConfig('Shipping (Display Currency)', Token.DisplayCurrency.Shipping)
    ];
};
const TypeConfigShippingV2 = {
    panel: {
        block: () => Content.TypeConfig.labelValue.panelV2.block(2, [{
            display: 'Display if shipping is 0',
            fullWidth: true,
            group: 'block',
            name: 'includeShippingZero',
            type: 'checkbox'
        }]),
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: 'Shipping' })),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: (data) => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Shipping}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Shipping }))
    }
};

// #endregion SHIPPING V2

// #region SUBTOTAL V2

function _SubtotalV2(props) { return <Content.LabelValue {...props} formatValue={false} value={props.content} /> }
const SubtotalV2 = Content.withLabelTokenParsing(_SubtotalV2, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.Subtotal:
            if (data.ExchangeRate && data.ExchangeRate.Subtotal != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Subtotal, options);
            }
            break;
        case Token.DisplayCurrency.SubtotalLessDiscount:
            if (data.ExchangeRate && data.ExchangeRate.SubtotalLessDiscount != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.SubtotalLessDiscount, options);
            }
            break;
        case Token.Total.Subtotal:
            if (data.Subtotal != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Subtotal, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        case Token.Total.SubtotalLessDiscount:
            if (data.SubtotalLessDiscount != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.SubtotalLessDiscount, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensSubtotal = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Subtotal', defaultValue, Token.Total.Subtotal),
        Token.getCurrencyTokenConfig('Subtotal (Discount Included)', defaultValue, Token.Total.SubtotalLessDiscount),
        Token.getWrappedTokenConfig('Subtotal (Display Currency)', Token.DisplayCurrency.Subtotal),
        Token.getWrappedTokenConfig('Subtotal (Discount Included - Display Currency)', Token.DisplayCurrency.SubtotalLessDiscount)
    ];
};
const TypeConfigSubtotalV2 = {
    panel: {
        block: Content.TypeConfig.labelValue.panelV2.block,
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: 'Subtotal' })),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: (data) => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Subtotal}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Subtotal }))
    }
};

// #endregion SUBTOTAL V2

// #region TAXES

function Taxes(props) {
    const data = props.data || {};
    if (!props.builder && (!data.Taxes || !data.Taxes.length)) {
        return null;
    }
    const config = props.config || {};
    let blockProps = {};
    if (config.Config && config.Config.Block) {
        blockProps = config.Config.Block;
    }
    const rowStyle = {};
    if (!Utilities.isNullOrWhitespace(blockProps.rowSpacing)) {
        rowStyle.paddingTop = blockProps.rowSpacing;
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragStart={props.onDragStart}>
            {
                data.Taxes &&
                data.Taxes.map((d, i) =>
                    <Content.LabelValue
                        key={i}
                        {...props}
                        container={false}
                        label={d.Name}
                        rowStyle={i > 0 ? rowStyle : undefined}
                        value={d.Amount} />
                )
            }
            {
                props.builder &&
                <tr>
                    <td>
                        {
                            (!data.Taxes || data.Taxes.length == 0) &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                </tr>
            }
        </Container>
    );
}
const TypeConfigTaxes = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    Content.TypeConfig.labelValue.options.displayType({ includeRows: false }),
                    {
                        display: 'Line Spacing',
                        name: 'rowSpacing',
                        type: 'text',
                        visible: function (config) {
                            return config.Block && config.Block.displayType == 'inline';
                        }
                    },
                    {
                        display: 'Row Spacing',
                        name: 'rowSpacing',
                        type: 'text',
                        visible: function (config) {
                            return config.Block && config.Block.displayType == 'columns';
                        }
                    },
                    { display: 'Label Properties', id: 'labelProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({}, undefined, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Value Properties', id: 'valueProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.value({}, {})
                ]
            };
        },
        format: Content.TypeConfig.labelValue.panel.format,
        style: function () { return TypeConfig.panel.layoutStyle({}, { visible: function (config) { return config.Block && config.Block.displayType == 'inline'; } }); }
    }
};

// #endregion TAXES

// #region TAXES V2

function TaxesV2(props) {
    const data = props.data || {};
    const hasTaxes = data.Taxes && data.Taxes.length > 0;
    if (!props.builder && !hasTaxes) {
        return null;
    }
    const config = props.config || {};
    let blockProps = {};
    if (config.config && config.config.Block) {
        blockProps = config.config.Block;
    }
    const rowStyle = {};
    if (blockProps.rowSpacing && !Utilities.isNullOrWhitespace(blockProps.rowSpacing.value)) {
        rowStyle.paddingTop = `${blockProps.rowSpacing.value}${blockProps.rowSpacing.unit}`;
    }
    const localization = data.Gallery && data.Gallery.Localization;
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            {
                data.Taxes &&
                data.Taxes.map((d, i) =>
                    <TaxLine
                        key={i}
                        {...props}
                        container={false}
                        data={d}
                        localization={localization}
                        rowStyle={i > 0 ? rowStyle : undefined} />
                )
            }
            {
                props.builder &&
                <tr>
                    <td>
                        {
                            !hasTaxes &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                </tr>
            }
        </Container>
    );
}
function _TaxLine(props) { return <Content.LabelValue {...props} formatValue={false} value={props.content} /> }
const TaxLine = Content.withLabelTokenParsing(_TaxLine, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.TaxValue:
            if (data.ExchangeRate && data.ExchangeRate.Value != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Value, options);
            }
            break;
        case Token.Total.Tax.Name:
            if (data.Name != undefined) {
                replaceString = data.Name;
            }
            break;
        case Token.Total.Tax.Value:
            if (data.Amount != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Amount, options && options.format, props.localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensTaxes = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        { display: 'Tax Name', token: Token.Total.Tax.Name },
        Token.getCurrencyTokenConfig('Tax Value', defaultValue, Token.Total.Tax.Value),
        Token.getWrappedTokenConfig('Tax Value (Display Currency)', Token.DisplayCurrency.TaxValue)
    ];
};
const TypeConfigTaxesV2 = {
    panel: {
        block: () => Content.TypeConfig.labelValue.panelV2.block(2, [{
            display: 'Tax Line Spacing',
            fullWidth: true,
            group: 'block',
            name: 'rowSpacing',
            options: TypeConfig.dropdown.measurement(),
            type: 'measurement-slider'
        }]),
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: `{${Token.Total.Tax.Name}}`, token: Token.Total.Tax.Name })),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: (data) => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Tax.Value}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Tax.Value }))
    }
};

// #endregion TAXES V2

module.exports = {
    Discount: {
        Component: Discount,
        TypeConfig: TypeConfigDiscount
    },
    DiscountV2: {
        Component: DiscountV2,
        Tokens: TokensDiscount,
        TypeConfig: TypeConfigDiscountV2
    },
    GrandTotal: {
        Component: GrandTotal,
        TypeConfig: TypeConfigGrandTotal
    },
    GrandTotalV2: {
        Component: GrandTotalV2,
        Tokens: TokensGrandTotal,
        TypeConfig: TypeConfigGrandTotalV2
    },
    Shipping: {
        Component: Shipping,
        TypeConfig: TypeConfigShipping
    },
    ShippingV2: {
        Component: ShippingV2,
        Tokens: TokensShipping,
        TypeConfig: TypeConfigShippingV2
    },
    SubtotalV2: {
        Component: SubtotalV2,
        Tokens: TokensSubtotal,
        TypeConfig: TypeConfigSubtotalV2
    },
    Taxes: {
        Component: Taxes,
        TypeConfig: TypeConfigTaxes
    },
    TaxesV2: {
        Component: TaxesV2,
        Tokens: TokensTaxes,
        TypeConfig: TypeConfigTaxesV2
    }
};